









import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'ZBOZIDRUH_OZN',
			apiProvider,
		};
	},
});
